/* FAQ: progressive enhancement only. Without this script every question still opens (native <details>), every
   chip still jumps, and #<id> still scrolls to its question. No layout reads while typing or scrolling: the one
   measurement (sticky offset) happens once at start and on resize. */
(function () {
  var root = document.querySelector('[data-faq]');
  if (!root) return;
  var doc = document.documentElement;
  doc.classList.add('js');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  var items = [].slice.call(root.querySelectorAll('details[data-q]'));
  var topics = [].slice.call(root.querySelectorAll('[data-topic]'));
  var topicLinks = [].slice.call(document.querySelectorAll('[data-topic-link]'));
  var form = root.querySelector('[data-faq-search]');
  var input = form && form.querySelector('input');
  var clearBtn = form && form.querySelector('[data-clear]');
  var status = root.querySelector('[data-status]');
  var announce = root.querySelector('[data-announce]');
  var empty = root.querySelector('[data-empty]');
  var emptyQ = root.querySelector('[data-empty-q]');
  var total = items.length;

  /* The theme's header group sticks to the top; the rail and the scroll padding sit just under it. One measurement at
     start, then a ResizeObserver, never in a scroll or input handler. */
  var hg = document.querySelector('#header-group');
  function measure() { if (hg) doc.style.setProperty('--faq-hdr', Math.ceil(hg.getBoundingClientRect().height) + 'px'); }
  if (hg) {
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(hg);
    else window.addEventListener('resize', measure);
  }

  function norm(s) { return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }
  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  var index = items.map(function (d) {
    var q = d.querySelector('[data-qtext]');
    var a = d.querySelector('[data-a]');
    var t = d.closest('[data-topic]');
    return { d: d, q: q, a: a, t: t, qHTML: q.innerHTML, aHTML: a.innerHTML,
      text: norm(q.textContent + ' ' + a.textContent + ' ' + (t.getAttribute('data-topic-name') || '')) };
  });

  function highlight(el, terms) {
    var re = new RegExp('(' + terms.map(esc).join('|') + ')', 'gi');
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) {
      var v = n.nodeValue;
      if (!re.test(v)) return;
      re.lastIndex = 0;
      var frag = document.createDocumentFragment();
      var last = 0;
      v.replace(re, function (m, _g, off) {
        if (off > last) frag.appendChild(document.createTextNode(v.slice(last, off)));
        var mk = document.createElement('mark');
        mk.className = 'hl';
        mk.textContent = m;
        frag.appendChild(mk);
        last = off + m.length;
        return m;
      });
      if (last < v.length) frag.appendChild(document.createTextNode(v.slice(last)));
      n.parentNode.replaceChild(frag, n);
    });
  }

  function say(el, text) { if (el) el.textContent = text; }

  var lastQ = '';
  function apply(raw, fromUser) {
    var q = (raw || '').trim();
    if (q === lastQ && fromUser) return;
    lastQ = q;
    var terms = norm(q).split(/\s+/).filter(Boolean);
    var hits = 0;
    var perTopic = new Map();
    index.forEach(function (it) {
      var hit = terms.every(function (t) { return it.text.indexOf(t) !== -1; });
      it.d.hidden = !hit;
      it.q.innerHTML = it.qHTML;
      it.a.innerHTML = it.aHTML;
      if (it.d.hasAttribute('data-auto')) { it.d.open = false; it.d.removeAttribute('data-auto'); }
      if (hit) {
        hits++;
        perTopic.set(it.t, (perTopic.get(it.t) || 0) + 1);
        if (terms.length) { highlight(it.q, terms); highlight(it.a, terms); }
      }
    });
    /* A short result list opens itself, so a match inside an answer shows where it is; those close again when the
       search changes. */
    if (terms.length && hits > 0 && hits <= 3) {
      index.forEach(function (it) { if (!it.d.hidden && !it.d.open) { it.d.setAttribute('data-auto', ''); it.d.open = true; } });
    }
    topics.forEach(function (t) { t.hidden = !perTopic.get(t); });
    topicLinks.forEach(function (l) {
      var t = document.getElementById(l.getAttribute('data-topic-link'));
      var n = perTopic.get(t) || 0;
      l.toggleAttribute('data-none', n === 0);
      var c = l.querySelector('[data-topic-count]');
      if (c) c.textContent = n;
    });
    if (empty) empty.hidden = hits > 0;
    if (emptyQ) emptyQ.textContent = q;
    if (clearBtn) clearBtn.hidden = !q;
    if (status) {
      var plural = hits === 1 ? ' question matches ' : ' questions match ';
      say(status, !terms.length ? '' : hits === 0 ? 'No questions match “' + q + '”' : hits + plural + '“' + q + '”');
      /* the empty state says it on screen; the status still announces it */
      status.classList.toggle('faq-vh', terms.length > 0 && hits === 0);
    }
    [].forEach.call(root.querySelectorAll('[data-topic-total]'), function (c) {
      var t = c.closest('[data-topic]');
      var all = c.getAttribute('data-topic-total');
      c.textContent = terms.length ? (perTopic.get(t) || 0) + ' of ' + all : all + (all === '1' ? ' question' : ' questions');
    });
    if (fromUser) {
      var url = location.pathname + (q ? '?q=' + encodeURIComponent(q) : '') + location.hash;
      history.replaceState(history.state, '', url);
    }
  }

  if (form && input) {
    form.hidden = false;
    var timer;
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(function () { apply(input.value, true); }, 120); });
    form.addEventListener('submit', function (e) { e.preventDefault(); apply(input.value, true); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape' && input.value) { input.value = ''; apply('', true); } });
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; apply('', true); say(status, 'Showing all ' + total + ' questions'); input.focus(); });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-try]');
      if (!b) return;
      input.value = b.getAttribute('data-try');
      apply(input.value, true);
      input.focus();
    });
    var start = new URLSearchParams(location.search).get('q');
    if (start) { input.value = start; apply(start, false); }
  }

  /* Deep links: /pages/faq#<id> opens that question and brings it into view */
  function clearSearch() { if (input && input.value) { input.value = ''; apply('', true); } }
  function openTarget(id, smooth) {
    if (!id) return;
    var el = document.getElementById(id);
    if (!el) return;
    if (el.matches('details[data-q]')) {
      if (el.hidden) clearSearch();
      el.open = true;
      el.removeAttribute('data-auto');
      requestAnimationFrame(function () {
        el.scrollIntoView({ block: 'start', behavior: smooth && !reduce ? 'smooth' : 'instant' });
      });
    } else if (el.matches('[data-topic]') && el.hidden) {
      clearSearch();
      requestAnimationFrame(function () { el.scrollIntoView({ block: 'start', behavior: 'instant' }); });
    }
  }
  function hashId() { try { return decodeURIComponent(location.hash.slice(1)); } catch (e) { return ''; } }
  openTarget(hashId(), false);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { var id = hashId(); var el = id && document.getElementById(id); if (el && el.matches('details[data-q]')) el.scrollIntoView({ block: 'start' }); });
  window.addEventListener('hashchange', function () { openTarget(hashId(), true); });
  /* A link to the question already in the address bar fires no hashchange, so open it on click too */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var el = document.getElementById(a.getAttribute('href').slice(1));
    if (el && el.matches('details[data-q]')) { if (el.hidden) clearSearch(); el.open = true; }
    if (el && el.matches('[data-topic]') && el.hidden) clearSearch();
  });

  /* The address follows the question a visitor opens, so it can be shared */
  items.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.hasAttribute('data-auto')) return;
      var base = location.pathname + location.search;
      if (d.open) history.replaceState(history.state, '', base + '#' + d.id);
      else if (hashId() === d.id) history.replaceState(history.state, '', base);
    });
  });

  /* Copy link */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b) return;
    var d = b.closest('details');
    var url = location.origin + location.pathname + '#' + d.id;
    var label = b.querySelector('.faq-copy__label');
    function done(ok) {
      b.classList.toggle('is-done', ok);
      label.textContent = ok ? 'Link copied' : 'Copy failed';
      say(announce, ok ? 'Link to this question copied' : 'Could not copy the link. The address bar has it.');
      if (!ok) history.replaceState(history.state, '', location.pathname + location.search + '#' + d.id);
      clearTimeout(b._t);
      b._t = setTimeout(function () { b.classList.remove('is-done'); label.textContent = 'Copy link'; }, 2200);
    }
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(function () { done(true); }, function () { done(fallback(url)); });
    } else { done(fallback(url)); }
  });
  function fallback(text) {
    var t = document.createElement('textarea');
    t.value = text; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
    document.body.appendChild(t); t.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(t);
    return ok;
  }
  [].forEach.call(root.querySelectorAll('[data-copy]'), function (b) { b.hidden = false; });

  /* Where you are: the topic under the sticky bar lights its chip or rail link */
  var spyTop = (parseFloat(getComputedStyle(doc).getPropertyValue('--faq-hdr')) || 104) + 40;
  var visible = new Set();
  var current = null;
  function setCurrent(t) {
    if (!t || t === current) return;
    current = t;
    topicLinks.forEach(function (l) {
      var on = l.getAttribute('data-topic-link') === t.id;
      if (on) l.setAttribute('aria-current', 'true'); else l.removeAttribute('aria-current');
    });
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) visible.add(en.target); else visible.delete(en.target); });
      var first = topics.filter(function (t) { return visible.has(t); })[0];
      if (first) setCurrent(first);
    }, { rootMargin: '-' + Math.round(spyTop) + 'px 0px -55% 0px' });
    topics.forEach(function (t) { io.observe(t); });

  }
})();
